import { render, staticRenderFns } from "./UbcId.vue?vue&type=template&id=4a7b3988&scoped=true"
import script from "./UbcId.vue?vue&type=script&lang=js"
export * from "./UbcId.vue?vue&type=script&lang=js"
import style0 from "./UbcId.vue?vue&type=style&index=0&id=4a7b3988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7b3988",
  null
  
)

export default component.exports